import {state} from '@bitstillery/mithril'
import {MithrilComponent} from '@bitstillery/mithril'
import {$t} from '@bitstillery/common/app'
import {unique_id} from '@bitstillery/common/lib/utils'
import {Button, ButtonGroup, Dialog, FieldRadio, FieldTextArea} from '@bitstillery/common/components'
import m from '@bitstillery/mithril'

import type {CampaignMnemonic} from '@bitstillery/common/api/fact2server'

export interface UnsubscribeSurveyAttrs {
    campaign: CampaignMnemonic
    className?: string
    onclose: () => unknown
    onsubmit: (is_unsubscribed: boolean, reason: string, comment: string) => unknown
}

interface SurveyData {
    comment: string
    selected_reason: string
}

export class Survey extends MithrilComponent<UnsubscribeSurveyAttrs> {
    data = state<SurveyData>(
        {
            comment: '',
            selected_reason: '',
        },
        'survey-data',
    )

    radio_name = unique_id()

    view(vnode: m.Vnode<UnsubscribeSurveyAttrs>) {
        return (
            <Dialog
                className='dialog-portal'
                footer={
                    <ButtonGroup>
                        <Button onclick={vnode.attrs.onclose} text={$t('campaign_preferences.survey.cancel')} variant='cta' />

                        <Button
                            disabled={this.data.selected_reason === ''}
                            onclick={async () => {
                                await vnode.attrs.onsubmit(true, this.data.selected_reason, this.data.comment)
                                vnode.attrs.onclose()
                            }}
                            text={$t('campaign_preferences.survey.submit')}
                            type='danger'
                            variant='cta'
                        />
                    </ButtonGroup>
                }
                title={$t('campaign_preferences.survey.title', {campaign: $t(`profile.campaigns.${vnode.attrs.campaign}`)})}
                type='info'
                onclose={vnode.attrs.onclose}
            >
                <div className='c-unsubscribe-survey'>
                    <div className='survey-description'>
                        <p>
                            {$t('campaign_preferences.survey.description', {
                                campaign: $t(`profile.campaigns.${vnode.attrs.campaign}`),
                            })}
                        </p>
                    </div>

                    <div className='survey-options'>
                        <div className='options-title'>
                            <h4>{$t('campaign_preferences.survey.options_title')}</h4>
                        </div>

                        <div className='radio-group'>
                            <FieldRadio
                                name={this.radio_name}
                                value='too_frequent'
                                label={$t('campaign_preferences.survey.reasons.too_frequent')}
                                help={$t('campaign_preferences.survey.reasons.too_frequent_help')}
                                model={this.data.$selected_reason}
                                onclick={() => {
                                    this.data.selected_reason = 'too_frequent'
                                }}
                            />

                            <FieldRadio
                                name={this.radio_name}
                                value='not_relevant'
                                label={$t('campaign_preferences.survey.reasons.not_relevant')}
                                help={$t('campaign_preferences.survey.reasons.not_relevant_help')}
                                model={this.data.$selected_reason}
                                onclick={() => {
                                    this.data.selected_reason = 'not_relevant'
                                }}
                            />

                            <FieldRadio
                                name={this.radio_name}
                                value='technical_issues'
                                label={$t('campaign_preferences.survey.reasons.technical_issues')}
                                help={$t('campaign_preferences.survey.reasons.technical_issues_help')}
                                model={this.data.$selected_reason}
                                onclick={() => {
                                    this.data.selected_reason = 'technical_issues'
                                }}
                            />

                            <FieldRadio
                                name={this.radio_name}
                                value='found_alternative'
                                label={$t('campaign_preferences.survey.reasons.found_alternative')}
                                help={$t('campaign_preferences.survey.reasons.found_alternative_help')}
                                model={this.data.$selected_reason}
                                onclick={() => {
                                    this.data.selected_reason = 'found_alternative'
                                }}
                            />

                            <FieldRadio
                                name={this.radio_name}
                                value='temporary_pause'
                                label={$t('campaign_preferences.survey.reasons.temporary_pause')}
                                help={$t('campaign_preferences.survey.reasons.temporary_pause_help')}
                                model={this.data.$selected_reason}
                                onclick={() => {
                                    this.data.selected_reason = 'temporary_pause'
                                }}
                            />

                            <FieldRadio
                                name={this.radio_name}
                                value='privacy_concerns'
                                label={$t('campaign_preferences.survey.reasons.privacy_concerns')}
                                help={$t('campaign_preferences.survey.reasons.privacy_concerns_help')}
                                model={this.data.$selected_reason}
                                onclick={() => {
                                    this.data.selected_reason = 'privacy_concerns'
                                }}
                            />

                            <FieldRadio
                                name={this.radio_name}
                                value='content_quality'
                                label={$t('campaign_preferences.survey.reasons.content_quality')}
                                help={$t('campaign_preferences.survey.reasons.content_quality_help')}
                                model={this.data.$selected_reason}
                                onclick={() => {
                                    this.data.selected_reason = 'content_quality'
                                }}
                            />

                            <FieldRadio
                                name={this.radio_name}
                                value='other'
                                label={$t('campaign_preferences.survey.reasons.other')}
                                help={$t('campaign_preferences.survey.reasons.other_help')}
                                model={this.data.$selected_reason}
                                onclick={() => {
                                    this.data.selected_reason = 'other'
                                }}
                            />

                            <FieldTextArea
                                placeholder={$t('campaign_preferences.survey.other_placeholder')}
                                label={$t('campaign_preferences.survey.other_label')}
                                model={this.data.$comment}
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
        )
    }
}
